import { render, staticRenderFns } from "./AccountNav.vue?vue&type=template&id=79de9b0e"
import script from "./AccountNav.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountNav.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports